import ChevronRightIcon from '../Icons/ChevronRight'
import IconButton from './IconButton'

interface IButtonRight {
    onClick(event?: any): void
    title?: string
}

const ButtonRight = ({ onClick, title }: IButtonRight) => (
    <IconButton title={title} onClick={onClick}>
        <ChevronRightIcon />
    </IconButton>
)

export default ButtonRight
